import { render, staticRenderFns } from "./AdminStatus.vue?vue&type=template&id=bb5a8226&"
import script from "./AdminStatus.vue?vue&type=script&lang=ts&"
export * from "./AdminStatus.vue?vue&type=script&lang=ts&"
import style0 from "./AdminStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports